import GitHub from "@material-ui/icons/GitHub";
import Facebook from "@material-ui/icons/Facebook";
import Instagram from "@material-ui/icons/Instagram";
import Twitter from "@material-ui/icons/Twitter";

export const socialList = [
  { icon: <GitHub />, link: "https://github.com/kleyla", text: "Kleyla" },
  {
    icon: <Facebook />,
    link: "https://www.facebook.com/karenleyla.rodriguez",
    text: "Karen Rodriguez",
  },
  {
    icon: <Instagram />,
    link: "https://www.instagram.com/karen.codes?r=nametag",
    text: "Karen Rodriguez",
  },
  {
    icon: <Twitter />,
    link: "https://twitter.com/KLEYLA1",
    text: "Karen Rodriguez",
  },
];
